import { Card, Checkbox, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { SETTING_KEY_TO_LABEL } from '../../constants';
import { useCustomerGroupBuilderForm } from '../../hooks/use-customer-group-builder-form';
import { ResetSettingsButton } from './reset-settings-button';

export function AllowCheckoutCard() {
  const form = useCustomerGroupBuilderForm();
  return (
    <Card showBorder>
      <Card.Header collapsible headingLevel="h2" icon="alertTriangle">
        {SETTING_KEY_TO_LABEL.allowCheckout}
      </Card.Header>
      <Card.Body>
        <Text variant="secondary">
          {t('features:customer_group.components.allow_checkout_card.description')}{' '}
          <LearnMoreLink link="https://docs.sparklayer.io/my-order-interface" />
        </Text>
        <form.Field name="settings.allowCheckout">
          {(field) => (
            <>
              <Checkbox
                label={t(
                  'features:customer_group.components.allow_checkout_card.disable_checkbox.label',
                )}
                description={t(
                  'features:customer_group.components.allow_checkout_card.disable_checkbox.description',
                )}
                checked={!field.state.value}
                onChange={() => field.handleChange((prev) => !prev)}
              />
              <div className="flex justify-start">
                <ResetSettingsButton field={field} />
              </div>
            </>
          )}
        </form.Field>
      </Card.Body>
    </Card>
  );
}
